module.exports = "https://r.nearpod.com/assets/media/image/slideshow-54ca2b8969530887047c75013003503a.svg";